module.exports = __webpack_public_path__ + "media/flags/ki-b5d51cf3.svg";